import { render, staticRenderFns } from "./image-overlay.vue?vue&type=template&id=ec0d7a02&scoped=true"
import script from "./image-overlay.vue?vue&type=script&lang=js"
export * from "./image-overlay.vue?vue&type=script&lang=js"
import style0 from "./image-overlay.vue?vue&type=style&index=0&id=ec0d7a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0d7a02",
  null
  
)

export default component.exports